(() => {
	angular
		.module('main')
		.controller('UpdateInvoiceController', UpdateInvoiceController);

	UpdateInvoiceController.$inject = ['$scope', '$routeParams'];

	function UpdateInvoiceController($scope, $routeParams) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.idToGetInvoice = $routeParams.jobId
				? parseInt($routeParams.jobId)
				: parseInt($routeParams.leadId);

			$scope.isJob = !!$routeParams.jobId;
			$scope.dataToGetInvoice = {
				id: $scope.idToGetInvoice,
				isJob: $scope.isJob,
				invoiceID: $routeParams.invoiceId
			};
		});
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/updateInvoiceController.js